import { ProjectDataProviderRepository } from '@goodt-common/data';
import { success, fail } from '@goodt-common/utils';
import { ValidationError } from '@goodt-common/errors';
import { ValidationErrorMessage } from '../const';

/**
 * @typedef {import('@goodt-common/data').IDatasetRequestProps} IDatasetRequestProps
 */

export class DatasetRequestValidator {
    _validateDataProvider(datasetRequest) {
        if (ProjectDataProviderRepository.getById(datasetRequest?.dataProviderId) == null) {
            const message = ValidationErrorMessage.DATA_PROVIDER_NOT_FOUND({ name: datasetRequest.dataProviderId });
            return fail(
                new ValidationError(message, {
                    property: 'dataProviderId'
                })
            );
        }
        return success(true);
    }

    /**
     * @return {SafeResult<IDatasetRequestProps, ValidationError>}
     */
    validate(datasetRequest) {
        return this._validateDataProvider(datasetRequest);
    }
}
